export default "__VITE_ASSET__B5ztE0Xf__"